import { CheckCircle, FileText, DollarSign, ShieldCheck } from 'lucide-react';

const PricingSection = () => {
  const highlights = [
    {
      icon: FileText,
      title: 'Written Estimates',
      description:
        'Every project receives a detailed written estimate before any work begins. No surprises.',
    },
    {
      icon: DollarSign,
      title: 'Flexible Budgets',
      description:
        'We work with various budget ranges and help you prioritize to get the most impact.',
    },
    {
      icon: ShieldCheck,
      title: 'No Hidden Charges',
      description:
        'Our quotes include all costs. Any scope changes are discussed and approved by you first.',
    },
  ];

  const factors = [
    'Room size and layout complexity',
    'Selected materials and finishes',
    'Level of customization required',
    'Project timeline preferences',
    'Existing furniture and decor integration',
  ];

  return (
    <section
      data-testid="pricing-section"
      className="section-padding bg-white"
    >
      <div className="container-main">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div>
            <span className="text-xs uppercase tracking-[0.3em] text-[#C5A065] mb-4 block">
              Transparent Pricing
            </span>
            <h2
              data-testid="pricing-title"
              className="font-heading text-3xl md:text-4xl text-[#2D2D2D] mb-6"
            >
              Clear, Honest Pricing
            </h2>
            <p className="text-[#6E6E6E] leading-relaxed mb-8">
              We believe in complete transparency when it comes to project
              costs. Every client receives a detailed breakdown before any work
              begins, ensuring you can make informed decisions.
            </p>

            {/* Pricing Highlights */}
            <div className="space-y-6 mb-8">
              {highlights.map((item, index) => (
                <div
                  key={index}
                  data-testid={`pricing-highlight-${index}`}
                  className="flex gap-4"
                >
                  <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#FAF9F6] flex items-center justify-center">
                    <item.icon className="w-5 h-5 text-[#C5A065]" />
                  </div>
                  <div>
                    <h3 className="font-heading text-lg text-[#2D2D2D] mb-1">
                      {item.title}
                    </h3>
                    <p className="text-[#6E6E6E] text-sm">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Factors Card */}
          <div className="bg-[#FAF9F6] p-8 md:p-12">
            <h3 className="font-heading text-2xl text-[#2D2D2D] mb-6">
              What Affects Pricing?
            </h3>
            <p className="text-[#6E6E6E] mb-8">
              Decoration costs vary based on several factors unique to each
              project:
            </p>
            <ul className="space-y-4">
              {factors.map((factor, index) => (
                <li
                  key={index}
                  data-testid={`pricing-factor-${index}`}
                  className="flex items-start gap-3"
                >
                  <CheckCircle className="w-5 h-5 text-[#C5A065] mt-0.5 flex-shrink-0" />
                  <span className="text-[#4A4A4A]">{factor}</span>
                </li>
              ))}
            </ul>
            <div className="mt-8 pt-8 border-t border-[#E5E0D8]">
              <p className="text-sm text-[#6E6E6E] italic">
                Schedule a free consultation to receive a personalized estimate
                for your specific project requirements.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
